/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CdsSoggettoServizio } from "./CdsSoggettoServizio";
import * as t from "io-ts";

// required attributes
const CdsSoggettoServizioListR = t.interface({
  subjectServices: t.readonlyArray(
    CdsSoggettoServizio,
    "array of CdsSoggettoServizio"
  )
});

// optional attributes
const CdsSoggettoServizioListO = t.partial({});

export const CdsSoggettoServizioList = t.intersection(
  [CdsSoggettoServizioListR, CdsSoggettoServizioListO],
  "CdsSoggettoServizioList"
);

export type CdsSoggettoServizioList = t.TypeOf<typeof CdsSoggettoServizioList>;
